import { mergeDefaults as _mergeDefaults, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-1264e7c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "approval-list" }
const _hoisted_2 = { class: "approval-content" }
const _hoisted_3 = { class: "approval-header" }
const _hoisted_4 = { class: "approval-title" }
const _hoisted_5 = { class: "approval-title__type" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "approval-title__colon" }, null, -1))
const _hoisted_7 = { class: "approval-title__detail" }
const _hoisted_8 = { class: "approval-info" }
const _hoisted_9 = { class: "approval-user" }
const _hoisted_10 = { class: "approval-time cm-ui-mr15" }
const _hoisted_11 = { class: "approval-item-actions" }

import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'
import { ElMessageBox } from 'element-plus'
import Card from '@/views/dashboard/_components/card/card.vue'
import EmptyData from '@/views/dashboard/_components/empty-data/empty-data.vue'
import { formatTimeStamp } from '@/utils/time'
import { ApiApprovalTypeEnum } from '@/views/dashboard/approval-center/types'


/** 与 defineProps withDefaults 第二项同源，供外部复用或测试引用 */
export const pendingApprovalListPropDefaults = {
  list: () => [],
  loading: false,
  maxItems: 5,
  viewMoreText: '',
  approveButtonText: undefined as string | undefined,
  rejectButtonText: undefined as string | undefined,
  approveButtonType: 'primary' as const,
  rejectButtonType: 'primary' as const,
  emptyText: '',
  itemClass: 'approval-item',
  dataType: 'custom' as const,
  approvalCenterRoute: '',
  showConfirmDialog: true,
  title: '',
  embed: false
}

// 通用审批项接口
export interface PendingApprovalItem {
  id?: string
  record_id?: string | number
  /** 审批类型：1 外设控制，2 敏感文件发送，3 级联审批 */
  approval_type?: number
  // 文件外发格式
  description?: string
  user?: string
  time?: string
  // USB外设格式
  peripheral_name?: string
  group_name?: string
  user_mark?: string
  apply_time?: number | string
  // 其他字段
  [key: string]: any
}

export default /*#__PURE__*/_defineComponent({
  __name: 'pending-approval-list',
  props: /*#__PURE__*/_mergeDefaults({
    list: {},
    loading: { type: Boolean },
    maxItems: {},
    viewMoreText: {},
    approveButtonText: {},
    rejectButtonText: {},
    approveButtonType: {},
    rejectButtonType: {},
    emptyText: {},
    itemClass: {},
    dataType: {},
    approvalCenterRoute: {},
    showConfirmDialog: { type: Boolean },
    title: {},
    embed: { type: Boolean }
  }, pendingApprovalListPropDefaults),
  emits: ["approve", "reject", "viewMore"],
  setup(__props: any, { emit: __emit }) {

const { t, locale } = useI18n()

const props = __props

const titleDisplay = computed(() => props.title || t('usbPolicy.pendingApprovalTitle'))
const viewMoreTextDisplay = computed(() => props.viewMoreText || t('usbPolicy.approvalCenter'))
const emptyTextDisplay = computed(() => props.emptyText || t('usbPolicy.noPending'))
const approveButtonTextDisplay = computed(
  () => props.approveButtonText ?? t('common.pass')
)
const rejectButtonTextDisplay = computed(
  () => props.rejectButtonText ?? t('common.reject')
)

const rowAttrs = computed(() => ({
  size: 'third' as const,
  class: ['approval-item-card', props.itemClass].filter(Boolean) as string[]
}))

const emit = __emit

const router = useRouter()

// 只显示前N条数据
const displayList = computed(() => {
  return (props.list || []).slice(0, props.maxItems)
})

// 获取标题
function getTitle(item: PendingApprovalItem): string {
  if (props.dataType === 'usb-peripheral') {
    return ` ${item.peripheral_name || t('usbPolicy.unknown')}`
  } else if (props.dataType === 'file-outbound') {
    return item.description
  }
  console.log('item :>> ', item);
  // 默认使用 description
  return item.description || item.peripheral_name
}

/** 类型名由 `approval_type` 决定；详情为 `getTitle` 原文（如接口返回的 content / 描述） */
function getApprovalTypePrefix (item: PendingApprovalItem): string | null {
  void locale.value
  const type = Number(item.approval_type)
  const map: Record<number, string> = {
    [ApiApprovalTypeEnum.Peripheral]: t('approvalCenter.typeNamePeripheral'),
    [ApiApprovalTypeEnum.FileOutbound]: t('approvalCenter.typeNameSensitiveFileSend'),
    [ApiApprovalTypeEnum.Cascade]: t('approvalCenter.typeNameCascadeApproval'),
  }
  const label = map[type]
  return label || null
}

function getTitleParts (item: PendingApprovalItem): { prefix: string; suffix: string } | null {
  const prefix = getApprovalTypePrefix(item)
  if (prefix == null) {
    return null
  }
  const raw = getTitle(item)
  console.log('raw :>> ', raw,item);
  const suffix = raw != null ? String(raw).trim() : ''
  return { prefix, suffix }
}

// 获取用户信息
function getUser(item: PendingApprovalItem): string {
  return (item.user||'--')+' / '+item.group_name
}

// 获取时间
function getTime(item: PendingApprovalItem): string {
   return formatTimeStamp(item.apply_time, 'YYYY-MM-DD HH:mm')
}

function handleApprove(item: PendingApprovalItem) {
  if (props.showConfirmDialog) {
    ElMessageBox.confirm(t('usbPolicy.approveConfirmMessage'), t('usbPolicy.dialogTip'), {
      confirmButtonText: t('common.confirm'),
      cancelButtonText: t('common.cancel')
    }).then(() =>
      ElMessageBox.confirm(t('usbPolicy.approveSecondConfirmMessage'), t('usbPolicy.dialogTip'), {
        confirmButtonText: t('common.confirm'),
        cancelButtonText: t('common.cancel')
      })
    ).then(() => {
      emit('approve', item)
    }).catch(() => {
      // 用户取消任一步
    })
  } else {
    emit('approve', item)
  }
}

function handleReject(item: PendingApprovalItem) {
  if (props.showConfirmDialog) {
    ElMessageBox.prompt(t('usbPolicy.pleaseRejectReason'), t('usbPolicy.dialogTip'), {
      confirmButtonText: t('common.confirm'),
      cancelButtonText: t('common.cancel'),
      inputPlaceholder: t('usbPolicy.pleaseRejectReason')
    }).then(({ value }) => {
      emit('reject', item, value)
    }).catch(() => {
      // 用户取消
    })
  } else {
    emit('reject', item)
  }
}

function handleViewMore() {
  emit('viewMore')
  if (props.approvalCenterRoute) {
    router.push(props.approvalCenterRoute)
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_button = _resolveComponent("el-button")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(Card, {
    size: "second",
    title: !_ctx.embed?titleDisplay.value : '',
    style: _normalizeStyle([!_ctx.embed?{padding:'16px'}:{padding:0}, {"height":"100%","box-sizing":"border-box"}]),
    border: !_ctx.embed
  }, _createSlots({
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displayList.value, (item, index) => {
          return (_openBlock(), _createBlock(Card, _mergeProps({
            key: item.id || item.record_id || index,
            ref_for: true
          }, rowAttrs.value), {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _renderSlot(_ctx.$slots, "title", { item: item }, () => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([getTitleParts(item)], (parts, titleIdx) => {
                        return (_openBlock(), _createElementBlock(_Fragment, { key: titleIdx }, [
                          parts
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createElementVNode("span", _hoisted_5, "[" + _toDisplayString(parts.prefix) + "]", 1),
                                _hoisted_6,
                                _createElementVNode("span", _hoisted_7, _toDisplayString(parts.suffix), 1)
                              ], 64))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode(_toDisplayString(getTitle(item)), 1)
                              ], 64))
                        ], 64))
                      }), 128))
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("span", _hoisted_9, [
                    _renderSlot(_ctx.$slots, "user", { item: item }, () => [
                      _createTextVNode(_toDisplayString(getUser(item)), 1)
                    ])
                  ]),
                  _createElementVNode("span", _hoisted_10, [
                    _renderSlot(_ctx.$slots, "time", { item: item }, () => [
                      _createTextVNode(_toDisplayString(getTime(item)), 1)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_el_button, {
                  size: "mini",
                  type: _ctx.approveButtonType,
                  onClick: ($event: any) => (handleApprove(item))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(approveButtonTextDisplay.value), 1)
                  ]),
                  _: 2
                }, 1032, ["type", "onClick"]),
                _createVNode(_component_el_button, {
                  size: "mini",
                  type: _ctx.rejectButtonType,
                  plain: "",
                  onClick: ($event: any) => (handleReject(item))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(rejectButtonTextDisplay.value), 1)
                  ]),
                  _: 2
                }, 1032, ["type", "onClick"])
              ])
            ]),
            _: 2
          }, 1040))
        }), 128)),
        (displayList.value.length === 0 && !_ctx.loading)
          ? (_openBlock(), _createBlock(EmptyData, {
              key: 0,
              text: emptyTextDisplay.value,
              height: "100%",
              "bg-color": "transparent"
            }, null, 8, ["text"]))
          : _createCommentVNode("", true)
      ])), [
        [_directive_loading, _ctx.loading]
      ])
    ]),
    _: 2
  }, [
    (!_ctx.embed)
      ? {
          name: "titleAfter",
          fn: _withCtx(() => [
            _createVNode(_component_el_tag, {
              size: "small",
              type: "primary"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('overviewZone.approvalListRecentFiveTag')), 1)
              ]),
              _: 1
            })
          ]),
          key: "0"
        }
      : undefined,
    (!_ctx.embed)
      ? {
          name: "headerRight",
          fn: _withCtx(() => [
            _createVNode(_component_el_button, {
              size: "mini",
              type: "primary",
              plain: "",
              onClick: handleViewMore
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(viewMoreTextDisplay.value), 1)
              ]),
              _: 1
            })
          ]),
          key: "1"
        }
      : undefined
  ]), 1032, ["title", "style", "border"]))
}
}

})